import { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingScreen } from '@/components/ui';
import { useAuth } from '@/contexts/AuthContext';
import { registeredRouteOr, route } from './paths';

interface PublicOnlyRouteProps {
    children?: ReactNode;
    /** Default redirect destination when no safe redirect source is available. */
    redirectTo?: string;
}

type RedirectState = {
    from?: {
        pathname?: string;
        search?: string;
    };
};

export function PublicOnlyRoute({
    children,
    redirectTo = route('home'),
}: PublicOnlyRouteProps) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <LoadingScreen />;
    }

    if (user) {
        const redirectParam = new URLSearchParams(location.search).get('redirect');
        const state = location.state as RedirectState | null;
        const requestedPath = state?.from?.pathname;
        const requestedSearch = state?.from?.search ?? '';
        const fromState = requestedPath ? `${requestedPath}${requestedSearch}` : null;

        const fallback = registeredRouteOr(redirectTo, route('home'));
        const destination = registeredRouteOr(redirectParam, registeredRouteOr(fromState, fallback));
        return <Navigate to={destination} replace />;
    }

    return children ?? <Outlet />;
}
